/**
 * @file This file polyfills needed functionality for older browsers. It exports a single promise
 * that will resolve when all needed features are polyfilled.
 */
// The following polyfil module reports a false-positive for unknown reasons.
// eslint-disable-next-line import/no-unresolved
import { isSupported as isPopoverSupported } from '@oddbird/popover-polyfill/fn';
const promises = [
    /** Our target browsers support Popover, but Cypress v11 does not. */
    new Promise(resolve => {
        if (!isPopoverSupported()) {
            import('@oddbird/popover-polyfill').then(() => {
                resolve();
            });
        }
        else {
            resolve();
        }
    }),
];
if (window.TextDecoderStream == null || window.TextEncoderStream == null) {
    promises.push(import('@stardazed/streams-text-encoding').then(pkg => {
        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
        window.TextDecoderStream = window.TextDecoderStream || pkg.TextDecoderStream;
        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
        window.TextEncoderStream = window.TextEncoderStream || pkg.TextEncoderStream;
    }));
}
export default Promise.all(promises).then(() => { });
